// extracted by mini-css-extract-plugin
export default {"badge":"ACBbVcR___badge","badge_new":"iCPnDfV___badge_new","badgeNew":"iCPnDfV___badge_new","badge_beta":"AKXu_NJ___badge_beta","badgeBeta":"AKXu_NJ___badge_beta"};